import { DropdownChangeEvent } from 'primeng/dropdown';
import {
  EoFormControlConfig,
  IEoFormControlConfig,
} from '../eo-form/eo-form.config';

export interface IEoDropdownConfig<T> extends IEoFormControlConfig {
  type?: 'dropdown';
  inputIcon?: string;
  inputStyleClass?: string;
  optionLabel?: string;
  optionValue?: string;
  options?: T[];
  dropdownStyleClass?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  showClear?: boolean;
  filter?: boolean;
  filterBy?: string;
  filterFields?: any[];
  filterPlaceholder?: string;
  appendTo?: any;
  apiUrl?: string;
  lazy?: boolean;
  filteredLazy?: boolean;
  onChange?: (value: DropdownChangeEvent) => void;
  group?: boolean;
  virtualScrollSize?: number;
  virtualScroll?: boolean;
}

export class EoDropdownConfig<T>
  extends EoFormControlConfig
  implements IEoDropdownConfig<T>
{
  override type?: 'dropdown';
  inputIcon?: string;
  inputStyleClass?: string;
  optionLabel?: string;
  optionValue?: string;
  options?: T[];
  dropdownStyleClass?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  showClear?: boolean;
  filter?: boolean;
  filterBy?: string;
  filterFields?: any[];
  filterPlaceholder?: string;
  appendTo?: any;
  apiUrl?: string;
  lazy?: boolean;
  filteredLazy?: boolean;
  override onChange?: (value: DropdownChangeEvent) => void;
  group?: boolean;
  virtualScrollSize?: number;
  virtualScroll?: boolean;

  constructor();
  constructor(obj: IEoDropdownConfig<T>);
  constructor(obj?: IEoDropdownConfig<T>) {
    super(obj as IEoFormControlConfig);
    this.type = 'dropdown';
    this.inputIcon = obj?.inputIcon;
    this.inputStyleClass = obj?.inputStyleClass;
    this.optionLabel = obj?.optionLabel;
    this.optionValue = obj?.optionValue;
    this.options = obj?.options;
    this.dropdownStyleClass = obj?.dropdownStyleClass;
    this.placeholder = obj?.placeholder;
    this.loadingPlaceholder = obj?.loadingPlaceholder;
    this.showClear = obj?.showClear;
    this.filter = obj?.filter;
    this.filterBy = obj?.filterBy;
    this.filterFields = obj?.filterFields;
    this.filterPlaceholder = obj?.filterPlaceholder;
    this.appendTo = obj?.appendTo;
    this.apiUrl = obj?.apiUrl;
    this.group = obj?.group;
    this.virtualScrollSize = obj?.virtualScrollSize;
    this.virtualScroll = obj?.virtualScroll;
    this.lazy = obj?.lazy;
    this.filteredLazy = obj?.filteredLazy;
  }
}
